import React from 'react';
import { useParams, Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import ProjectFilesManager from '@/components/ProjectFilesManager';

export default function ProjectFiles() {
  const { id } = useParams();

  return (
    <div>
      <div className="border-b border-border px-8 lg:px-12 py-8">
        <Link to={`/projects/${id}`} className="inline-flex items-center gap-2 text-sm text-muted-foreground hover:text-foreground mb-4">
          <ArrowLeft className="h-4 w-4" />
          Back to Project
        </Link>
        <div className="eyebrow mb-2">Project Files</div>
        <h1 className="font-display text-4xl font-black tracking-tight">File Library</h1>
        <p className="text-sm text-muted-foreground mt-2">Centralized storage for all project-related files and documents</p>
      </div>

      <div className="p-8 lg:p-12">
        <ProjectFilesManager projectId={id} />
      </div>
    </div>
  );
}
